module.exports = __webpack_public_path__ + "images/Babytree_Group-adf945.png";